// Script to detect specific elements on the e-cycle course page and store their values in sessionStorage
(function() {
  // Only run this script on the specified page
  if (window.location.href.includes('e-cycle.online/apps/ldt-course')) {
    console.log('Script activated on e-cycle course page');
    
    // Use MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(function(mutations) {
      // Check if the elements we're looking for exist
      const completedElement = document.querySelector(".ldt-cr-course-completed-date");
      const createdElement = document.querySelector(".ldt-cr-course-enrollment-date");
      
      // If completed date element exists, store its value
      if (completedElement) {
        const completedAt = completedElement.innerHTML;
        console.log('Found completed date:', completedAt);
        sessionStorage.setItem('courseCompletedAt', completedAt);
      }
      
      // If enrollment date element exists, store its value
      if (createdElement) {
        const createdAt = createdElement.innerHTML;
        console.log('Found enrollment date:', createdAt);
        sessionStorage.setItem('courseCreatedAt', createdAt);
      }
      
      // If both elements are found, we can disconnect the observer
      if (completedElement && createdElement) {
        console.log('Both elements found, disconnecting observer');
        observer.disconnect();
      }
    });
    
    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Also check immediately in case elements are already present
    const completedElement = document.querySelector(".ldt-cr-course-completed-date");
    const createdElement = document.querySelector(".ldt-cr-course-enrollment-date");
    
    if (completedElement) {
      const completedAt = completedElement.innerHTML;
      console.log('Initially found completed date:', completedAt);
      sessionStorage.setItem('courseCompletedAt', completedAt);
    }
    
    if (createdElement) {
      const createdAt = createdElement.innerHTML;
      console.log('Initially found enrollment date:', createdAt);
      sessionStorage.setItem('courseCreatedAt', createdAt);
    }
  }
})();